import { NgModule } from '@angular/core';
import { FilterPipe } from './filter/filter';
import { SearchFilterPipe } from './filter/searchfilter';
import { DateTimeRecentPipe } from './date-time-recent.pipe';
@NgModule({
  declarations: [FilterPipe, SearchFilterPipe, DateTimeRecentPipe],
  imports: [],
  exports: [FilterPipe, SearchFilterPipe, DateTimeRecentPipe],
})
export class PipesModule {}
